/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {WarmupCustomerContextRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/chat_messages.pb'
import {WarmupCustomerContextResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/chat_messages.pb'


export const warmupCustomerContext = (request: WarmupCustomerContextRequest, options?: CashRequestOptions) => post<WarmupCustomerContextRequest, WarmupCustomerContextResponse>("/cash-app/goose-cash/v3/warmup-customer-context", request, {...options, rejectOnError: true })